module.exports = __webpack_public_path__ + "static/15-66c7839896f4c9c58a4933b633b08dcf.jpg";